"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _index = require("./index");
var _typography = require("../../typography");
var _compact_row = require("../../layouts/compact_row");
var _buttons = require("../buttons");
var _close = _interopRequireDefault(require("../../icons/close"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = _interopRequireDefault(require("./theme"));
var _grid = require("../../layouts/grid");
var _warning = require("../../utils/warning");
var _excluded = ["size", "children", "onSubmit"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DATA_ENTRY_MODAL_SIZE_MAP = {
  medium: '600px',
  large: '800px',
  extraLarge: '1000px'
};
var DataEntryModal = function DataEntryModal(props) {
  var size = props.size,
    children = props.children,
    onSubmit = props.onSubmit,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (onSubmit) {
    (0, _warning.warnInDevelopmentOnce)('Using onSubmit in DataEntryModal is deprecated. Use the <Form> component to manage form submission instead: https://grnhse.github.io/seedling/?path=/docs/birch-forms--docs');
  }
  var submitWithoutDefault = function submitWithoutDefault(e) {
    e.preventDefault();
    onSubmit === null || onSubmit === void 0 || onSubmit(e);
  };
  return /*#__PURE__*/React.createElement(_index.ThemeableModal, (0, _extends2["default"])({
    maxWidth: DATA_ENTRY_MODAL_SIZE_MAP[size],
    onSubmit: onSubmit ? submitWithoutDefault : undefined
  }, rest), children);
};
var DataEntryModalHeader = function DataEntryModalHeader(props) {
  var children = props.children,
    onClick = props.onClick;
  return /*#__PURE__*/React.createElement(_index.ThemeableModal.Header, null, /*#__PURE__*/React.createElement(_typography.SectionHeader, {
    large: true
  }, /*#__PURE__*/React.createElement(_compact_row.CompactRow, {
    spacing: 2,
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    wrap: 'nowrap'
  }, children, /*#__PURE__*/React.createElement(_buttons.IconButton, {
    icon: _close["default"],
    label: 'close-modal-icon',
    onClick: onClick
  }))));
};
DataEntryModalHeader.displayName = 'DataEntryModal.Header';
DataEntryModal.Header = DataEntryModalHeader;
DataEntryModal.Body = _index.ThemeableModal.Body;
DataEntryModal.Body.displayName = 'DataEntryModal.Body';
var DataEntryModalFooter = function DataEntryModalFooter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledFooter, null, /*#__PURE__*/React.createElement(_index.ThemeableModal.Footer, {
    paddingOverrides: {
      paddingTop: _index.verticalPadding
    }
  }, /*#__PURE__*/React.createElement(_grid.Grid, {
    container: true,
    justifyContent: 'flex-end',
    spacing: 2,
    alignItems: 'center'
  }, children)));
};
DataEntryModalFooter.displayName = 'DataEntryModal.Footer';
DataEntryModal.Footer = DataEntryModalFooter;
var StyledFooter = _styledComponents["default"].div.withConfig({
  displayName: "data_entry_modal__StyledFooter"
})(["border-top:1px solid ", ";"], _theme["default"].dataEntryModalFooter.borderTop);
var _default = exports["default"] = DataEntryModal;